import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_SERVER_ADDRESS } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ParadasService {

  constructor(private http: HttpClient) { }


  // Gestión de Paradas
  getParadas(): Observable<any> {
    return this.http.get(`${API_SERVER_ADDRESS}/v1/paradas`).pipe(
      map(results => results['paradas'])
    );
  }

  getNearestParadas(position, amount): Observable<any> {
    return this.http.get(`${API_SERVER_ADDRESS}/v1/paradas/nearest/${position.lat}/${position.lon}/${amount}`).pipe(
      map(results => results['paradas'])
    )
  }

}